// extracted by mini-css-extract-plugin
export default {"productCardBox":"ProductCardBox_productCardBox__Qqymo"};